import React from "react";

/**
 * ModuleDivider — where a module begins in a list of classes formed from a
 * module-wise syllabus.
 *
 * Props: number, title
 */
const ModuleDivider = ({ number, title }) => (
  <h3 className="tw-m-0 tw-mb-1 tw-mt-4 tw-flex tw-items-center tw-gap-2 tw-text-xs tw-font-semibold tw-uppercase tw-tracking-caps tw-text-content-muted first:tw-mt-0">
    <span className="tw-rounded-sm tw-bg-primary/10 tw-px-1.5 tw-py-0.5 tw-text-primary">Module {number}</span>
    <span className="tw-min-w-0 tw-truncate">{title}</span>
  </h3>
);

export default ModuleDivider;
